import { createSlice } from "@reduxjs/toolkit";
import {
	checkDownloadEligibility,
	fetchDownloadVersions,
} from "../thunks/trackThunks";

const initialState = {
	isChecking: false,
	error: null,
	response: null,
};

const downloadTrackSlice = createSlice({
	name: "downloadEligibility",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(checkDownloadEligibility.pending, (state) => {
				state.isChecking = true;
			})
			.addCase(checkDownloadEligibility.fulfilled, (state, action) => {
				state.isChecking = false;
				state.response = action.payload;
			})
			.addCase(checkDownloadEligibility.rejected, (state, action) => {
				state.isChecking = false;
				state.error =
					action.error.message ||
					"Failed to check download eligibility";
			});
	},
});

const downloadVersionsSlice = createSlice({
	name: "downloadVersions",
	initialState: {
		isLoading: false,
		error: null,
		versions: {},
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchDownloadVersions.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(fetchDownloadVersions.fulfilled, (state, action) => {
				state.isLoading = false;
				state.versions = action.payload;
			})
			.addCase(fetchDownloadVersions.rejected, (state, action) => {
				state.isLoading = false;
				state.error =
					action.error.message || "Failed to fetch download versions";
			});
	},
});

export const downloadTrackReducer = downloadTrackSlice.reducer;
export const downloadVersionsReducer = downloadVersionsSlice.reducer;
